var path = '/pages/billing/invoice_templates/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing/invoice_templates/views/list.tpl.html
// module id = 2187
// module chunks = 1